import { Plus } from 'lucide-react'
import { useRef } from 'react'

import { Button } from '@/components/ui/button'
import { ACCEPTED_EXTENSIONS } from '@/hooks/useFileUploads'

interface AttachmentPickerProps {
  onFiles: (files: File[]) => void
  disabled?: boolean
}

export function AttachmentPicker({ onFiles, disabled }: AttachmentPickerProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  function handleClick() {
    if (disabled) return
    inputRef.current?.click()
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target.files
    if (!files || files.length === 0) return
    onFiles(Array.from(files))
    // Reset so selecting the same file again re-fires onChange.
    e.target.value = ''
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPTED_EXTENSIONS.join(',')}
        className="hidden"
        onChange={handleChange}
        disabled={disabled}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        disabled={disabled}
        onClick={handleClick}
        aria-label="Attach files"
        className="text-muted-foreground hover:text-foreground"
      >
        <Plus className="size-5" />
      </Button>
    </>
  )
}
